<template>
  <form @submit.prevent="save">
    <b-modal
      :visible="visible"
      :title="$t('Add object', { object: $tc('Colors Maps', 1) })"
      @hide="hide"
    >
      <div v-loading="loading">
        <div class="row">
          <div
            v-for="code in languagesCodes"
            :key="code"
            class="col-4"
          >
            <div class="form-group">
              <label>{{ code.toUpperCase() }}</label>
              <input
                v-model="model[code]"
                type="text"
                class="form-control"
                required
                maxlength="100"
              >
            </div>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <input
          :value="$t('Add')"
          type="submit"
          class="btn btn-primary"
        >
        <b-button @click="hide">
          {{ $t('Close') }}
        </b-button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import ColorsMapsService from '../../services/ColorsMapsService';
import Languages from '../Localization/Languages';

export default {
  name: 'AppColorsMapsAddModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      visible: this.value,
      loading: false,
      model: {},
    };
  },
  computed: {
    languagesCodes() {
      return Languages.codes();
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        const model = {};
        Languages.codes().forEach(code => {
          model[code] = '';
        });
        this.model = model;
        this.visible = v;
      },
    },
  },
  methods: {
    hide() {
      this.visible = false;
      this.$emit('input', false);
    },
    save() {
      this.loading = true;
      ColorsMapsService.create(this.model).then(() => {
        this.$notifications_success(this.$t('Action', { object: this.$tc('Colors Maps', 1), action: this.$t('added') }));
        this.loading = false;
        this.$emit('saved');
      }).catch(e => {
        this.$notifications_error(e.message);
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~bootstrap-vars";

  .marketplaces-control {
    max-height: 70vh;
    overflow: hidden auto;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: .6rem;
        border: $gray-400 1px solid;
        margin-bottom: 5px;
        cursor: pointer;
        overflow: auto;

        div {
          float: left;
        }

        &:hover {
          background-color: $gray-100;
        }
      }
    }

    &__arrow {
      margin-left: 5px;

      &--right {
        margin-left: 0;
        margin-right: 5px;
        float: right !important;
      }
    }
  }
</style>
